import Dexie from 'dexie';

// Banco local (IndexedDB) para cache de leitura offline.
// Tabela única e genérica: cada resposta GET é guardada por uma cacheKey
// (normalmente a URL do endpoint). Nível 1 = só leitura, sem sincronização.
export const cacheDb = new Dexie('sigo-cache');

cacheDb.version(1).stores({
  // cacheKey é a chave primária; updatedAt indexado para poda por antiguidade.
  responses: 'cacheKey, updatedAt',
});

// Teto de entradas para evitar que o IndexedDB cresça sem limite.
// Só cacheamos JSON (texto), então cada entrada é pequena; 300 entradas
// cobrem muitos pacientes/consultas sem passar de poucos MB.
const MAX_ENTRIES = 300;

// Lê uma entrada do cache. Retorna { data, updatedAt } ou null se não existir.
export async function readCache(cacheKey) {
  const entry = await cacheDb.responses.get(cacheKey);
  return entry ?? null;
}

// Grava (ou sobrescreve) uma entrada e poda as mais antigas se passar do teto.
export async function writeCache(cacheKey, data) {
  await cacheDb.responses.put({ cacheKey, data, updatedAt: Date.now() });
  await pruneOldEntries();
}

// Poda LRU simples: se exceder MAX_ENTRIES, remove as mais antigas
// (menor updatedAt) até voltar ao teto.
async function pruneOldEntries() {
  const total = await cacheDb.responses.count();
  if (total <= MAX_ENTRIES) return;
  const excess = total - MAX_ENTRIES;
  const oldestKeys = await cacheDb.responses.orderBy('updatedAt').limit(excess).primaryKeys();
  await cacheDb.responses.bulkDelete(oldestKeys);
}

// Limpa todo o cache (ex.: logout). Best-effort.
export async function clearCache() {
  await cacheDb.responses.clear();
}
